module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bEYnG"))).then(() => parcelRequire('1iHdE'));